var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container",attrs:{"id":"today"}},[_c('div',{staticClass:"container mt-3"},[_c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{attrs:{"border-variant":"success","align":"center"}},[_c('ChartDemo')],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }